import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
})
function isIE() {
  if (!!window.ActiveXObject || "ActiveXObject" in window)
    return true;
  else
    return false;
}
//判断浏览器类型
// function getweb() {
//   if ((!!window.ActiveXObject || "ActiveXObject" in window){
//     return "IE";
//   }
//   ifnavigator.userAgent.indexOf("Firefox") != -1) {
//     return "Firefox";
//   }
//   if (navigator.userAgent.indexOf("Chrome") != -1) {
//     return "Chrome";
//   }
//   if (navigator.userAgent.indexOf("Safari") != -1) {
//     return "Safari";
//   }
// }

Vue.prototype.$isIE = isIE();
//alert(Vue.prototype.isIE)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
